<template>
  <VMenu
    v-model="model"
    :close-on-content-click="props.closeOnContentClick"
    :open-on-hover="props.openOnHover"
    :open-on-click="props.openOnClick"
    :location="props.location"
    :location-strategy="props.locationStrategy"
    :offset="props.offset"
    :open-delay="props.openDelay"
    :target="target"
    :transition="props.transition"
    :content-class="props.contentClass"
    :disabled="props.disabled"
    :activator="props.activator"
  >
    <template
      v-if="slots['activator'] && !props.activator"
      #activator="{ props: vMenuProps }"
    >
      <slot
        name="activator"
        :v-menu-props="vMenuProps"
      />
    </template>
    <VCard>
      <slot v-if="!props.menuItems" />
      <EasyList
        v-else
        class="menu-list"
        :items="props.menuItems"
        data-cy="list__menu-items--easy-ui"
        @click:menu-item="emitMenuItem"
      />
    </VCard>
  </VMenu>
</template>

<script setup lang="ts">
import { useSlots } from "vue";
import { Anchor } from "@/src/easy-ui/types/easyMenu";
import { VuetifyLocationStrategies } from "@/src/easy-ui/types";
import { VueSlots } from "@/src/shared/types/slot";
import { ListItem } from "@/src/easy-ui/types/easyList";
import EasyList from "@/src/easy-ui/components/EasyList.vue";

interface Props {
  menuItems?: ListItem[];
  closeOnContentClick?: boolean;
  contentClass?: string;
  openOnHover?: boolean;
  openOnClick?: boolean;
  openDelay?: number | string;
  location?: Anchor;
  offset?: string | number | number[];
  target?: [number, number];
  transition?: string;
  locationStrategy?: VuetifyLocationStrategies;
  disabled?: boolean;
  activator?: HTMLElement | string;
}

const props = withDefaults(defineProps<Props>(), {
  menuItems: undefined,
  closeOnContentClick: true,
  contentClass: "",
  openOnHover: false,
  openOnClick: undefined,
  openDelay: 300,
  offset: undefined,
  target: undefined,
  transition: "fade-transition",
  location: Anchor.Bottom,
  locationStrategy: VuetifyLocationStrategies.Connected,
  disabled: false,
  activator: undefined,
});

const model = defineModel<boolean>({ required: true });

interface Emits {
  (e: "click:menu-item", item: ListItem): void;
}

const emits = defineEmits<Emits>();

const slots = useSlots() as VueSlots<["activator"]>;

const emitMenuItem = (item: ListItem) => {
  emits("click:menu-item", item);
};
</script>
